<p-tabView class="border-round-3xl" [(activeIndex)]="tabindex" (onChange)="handleTavChange($event)">
    <!-- <p-tabPanel>
        <ng-template pTemplate="header">
            <div class="flex align-items-center ">
                <span class="font-bold white-space-nowrap m-0">
                    <span class="pi pi-search"></span> Suche
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="content"> <app-search></app-search></ng-template>
    </p-tabPanel> -->
    <p-tabPanel>
        <ng-template pTemplate="header">
            <div class="flex align-items-center ">
                <span class="font-bold white-space-nowrap m-0">
                    <span class="pi pi-barcode"></span> Chargenübersicht
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="content"> <app-charge-list></app-charge-list></ng-template>
    </p-tabPanel>
</p-tabView>